import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const solutionContent = {
  title: 'La colección clínica definitiva para tu consulta',
  description: 'Diseñamos este pack pensando exactamente en lo que necesitás como profesional de estimulación temprana: herramientas clínicas, fichas de observación, estrategias terapéuticas y material visual para trabajar cada área del neurodesarrollo.',
  features: ['6 tomos especializados en neurodesarrollo infantil', 'Material 100% editable y listo para imprimir', 'Fichas de observación y registros evolutivos profesionales', 'Estrategias basadas en evidencia para TEA, TDAH y otros desafíos'],
  imageUrl: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?q=80&w=1000&auto=format&fit=crop',
  imageAlt: 'Profesional de estimulación temprana trabajando con un niño'
};
export function Solution() {
  return <section className="py-24 px-4 bg-[#0f0f0f]" data-id="element-204">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-206">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 text-brand-light" data-id="element-207">
            {solutionContent.title}
          </h2>
          <p className="text-lg text-brand-light/70 mb-8 font-sans leading-relaxed" data-id="element-208">
            {solutionContent.description}
          </p>

          <ul className="space-y-4" data-id="element-209">
            {solutionContent.features.map((feature, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-3 text-brand-light/90" data-id="element-210">
                <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-211" />
                <span data-id="element-212">{feature}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-213">
          <div className="absolute inset-0 bg-brand-accent/20 rounded-2xl blur-2xl -z-10" data-id="element-214" />
          <img src={solutionContent.imageUrl} alt={solutionContent.imageAlt} className="rounded-2xl border border-brand-cardBorder shadow-xl w-full object-cover aspect-[4/3]" data-id="element-215" />
        </motion.div>
      </div>
    </section>;
}